import { formatedDateWP } from "../../lib/dateFormater";

export const removeTag = (tag) => {
  return tag.replace(/<\/?[^>]+(>|$)/g, "") || "";
};

export const singleNewsDataDeserializer = (data) => {
  if (!data.id) {
    return null;
  }
  return {
    id: data?.id,
    title: removeTag(String(data?.title?.rendered)),
    metaDescription: removeTag(String(data?.excerpt?.rendered)),
    slug: data?.slug,
    ogImage:
      data?._embedded["wp:featuredmedia"][0].source_url || "/ogImage.jpg",
    // content: removeTag(String(data?.content?.rendered)),
    content: data?.content?.rendered,
    category: {
      id: data["_embedded"]["wp:term"][0][0].id,
      name: data["_embedded"]["wp:term"][0][0].name,
    },
    date: formatedDateWP(data.date) || "",
    image: data?._embedded["wp:featuredmedia"][0].source_url || "",
    categories: data?.categories || [],
  };
};

export const newsThumbnailsDeserializer = (data) => {
  if (!data.id) {
    return null;
  }
  return {
    id: data.id,
    img: data?.["_embedded"]["wp:featuredmedia"][0]?.source_url || "",
    imgAlt:
      data?.["_embedded"]["wp:featuredmedia"][0].alt_text || "about digikala",
    title: removeTag(String(data.title.rendered)) || "",
    catTitle: data?.["_embedded"]["wp:term"][0][0].name || "",
    date: formatedDateWP(data.date) || "",
    duration: undefined,
    slug: data?.slug,
    link: `/newsroom/${data.slug}` || "/404",
  };
};
